import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    width: 20px;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-size: 22px;\n  width: 42px;\n  opacity: 0.5;\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 28px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n    line-height: 22px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: 25px;\n    font-size: 12px;\n    line-height: 16px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  /* Chrome, Safari, Edge, Opera */\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  /* Firefox */\n  -moz-appearance: textfield;\n  font-size: 22px;\n  line-height: 27px;\n  width: 50px;\n  text-align: center;\n  font-family: ", ";\n  & {\n    border: none;\n  }\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    background-color: transparent;\n    opacity: 0.5;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    bottom: -8px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 50%;\n  transform: translateX(50%);\n  bottom: 0;\n  white-space: nowrap;\n  bottom: -6px;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { extraFontFamily } from "@temp/@next/globalStyles/constants";
export var NumberField = styled.div(_templateObject());
export var ErrorMessages = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()));
export var Input = styled.input(_templateObject4(), extraFontFamily, media.xxLargeScreen(_templateObject5()), media.xLargeScreen(_templateObject6()), media.smallScreen(_templateObject7()));
export var Button = styled.button(_templateObject8(), media.xxLargeScreen(_templateObject9()), media.smallScreen(_templateObject10()));
export var Middle = styled.div(_templateObject11());